import {
  LabOrderAttributes,
  LabOrderModel,
} from '@common/models/LabOrderModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from './serviceHelper';

export class LabOrderService {
  private static baseUrl: string = '/api/laborder';
  private static publicUserHeader: any = {
    vpca: '351BD313-2C19-442B-BC87-C69356EB59EF',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  };

  public static tags = {
    createLabOrder: 'createLabOrder',
    getLabOrder: 'getLabOrder',
    getPublicLabOrder: 'getPublicLabOrder',
    cancelLabOrder: 'cancelLabOrder',
    reviewLabOrder: 'reviewLabOrder',
    updateNotesLabOrders: 'updateLabOrders',
    getLabOrderAttributes: 'getLabOrderAttributes',
  };

  static updateNotesLabOrders = (
    labOrderModel: LabOrderModel,
  ): Promise<LabOrderModel> => {
    return trackPromise(
      new Promise<LabOrderModel>((resolve, reject) => {
        http(`${this.baseUrl}/updatenoteslaborder/${labOrderModel.labOrderId}`)
          .post<LabOrderModel>(labOrderModel)
          .then((json) => {
            return new LabOrderModel(json);
          })
          .then(resolve)
          .catch((error) => {
            ServiceHelper.showError(
              'Failed to saved notes to lab order.',
              undefined,
            );
            reject(error);
          });
      }),
      this.tags.updateNotesLabOrders,
    );
  };

  static getLabOrder = (labOrderId: number): Promise<LabOrderModel> => {
    return trackPromise(
      new Promise<LabOrderModel>((resolve, reject) => {
        http(`${this.baseUrl}/${labOrderId}`)
          .get<LabOrderModel>()
          .then((json) => {
            return new LabOrderModel(json);
          })
          .then(resolve)
          .catch((error) => {
            ServiceHelper.showError('Failed to open lab order.', undefined);
            reject(error);
          });
      }),
      this.tags.createLabOrder,
    );
  };

  static getLabOrderAttributes = (
    visitSalesItemId: number,
  ): Promise<LabOrderAttributes> => {
    return trackPromise(
      new Promise<LabOrderAttributes>((resolve, reject) => {
        http(`${this.baseUrl}/labordertest/${visitSalesItemId}`)
          .get<LabOrderAttributes>()
          .then((json) => {
            return json as LabOrderAttributes;
          })
          .then(resolve)
          .catch((error) => {
            ServiceHelper.showError(
              'Failed to get lab order attributes.',
              undefined,
            );
            reject(error);
          });
      }),
      this.tags.getLabOrderAttributes,
    );
  };

  static createLabOrder = (
    visitId: number,
    ihd: boolean,
    selectedIvlsDevice: string | null,
  ): Promise<LabOrderModel> => {
    return trackPromise(
      new Promise<LabOrderModel>((resolve, reject) => {
        const url = selectedIvlsDevice
          ? `${this.baseUrl}/createrequest/${visitId}/${ihd}/${selectedIvlsDevice}`
          : `${this.baseUrl}/createrequest/${visitId}/${ihd}`;
        http(url)
          .post<LabOrderModel>({})
          .then((json) => {
            return new LabOrderModel(json);
          })
          .then(resolve)
          .catch(reject);
      }),
      this.tags.createLabOrder,
    );
  };

  static updateLabOrder = (labOrderId: number): Promise<LabOrderModel> => {
    return trackPromise(
      new Promise<LabOrderModel>((resolve, reject) => {
        http(`${this.baseUrl}/updatelaborderfromidexx/${labOrderId}`)
          .post<LabOrderModel>({})
          .then((json) => new LabOrderModel(json))
          .then(resolve)
          .catch(reject);
      }),
      this.tags.createLabOrder,
    );
  };

  static cancelLabOrder = (labOrderId: number): Promise<LabOrderModel> => {
    return trackPromise(
      new Promise<LabOrderModel>((resolve, reject) => {
        http(`${this.baseUrl}/cancellaborder/${labOrderId}`)
          .deleteWithResponse<LabOrderModel>()
          .then((json) => new LabOrderModel(json))
          .then(resolve)
          .catch(reject);
      }),
      this.tags.cancelLabOrder,
    );
  };

  static reviewLabOrder = (labOrderId: number): Promise<LabOrderModel> => {
    return trackPromise(
      new Promise<LabOrderModel>((resolve, reject) => {
        http(`${this.baseUrl}/reviewlaborder/${labOrderId}`)
          .post<LabOrderModel>({})
          .then((json) => new LabOrderModel(json))
          .then(resolve)
          .catch(reject);
      }),
      this.tags.reviewLabOrder,
    );
  };
}
